<template>
	<div class='field-container'>
		<div v-if='label' class='label-wrapper'>
			<label class='label' :id="id + '_label'" :for="id" v-html='label'></label><i v-if='mandatory' class="fas fa-asterisk mandatory"></i>
		</div>
		<div class='field-wrapper'>
			<div ref='input_field' class='input-field'>
				<slot></slot>
				<button
					v-if='show_password_toggle'
					type='button'
					class='password-toggle-btn'
					@click.prevent='togglePasswordVisibility'
					:aria-label='password_visible ? "Hide password" : "Show password"'
				>
					<svg v-if='!password_visible' xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
						<path d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z'/>
						<circle cx='12' cy='12' r='3'/>
					</svg>
					<svg v-else xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
						<path d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'/>
					</svg>
				</button>
			</div>
			<FieldError :errors='errors' :field_id='id'/>
		</div>
	</div>
</template>

<script>
import FieldError from '@/ecom/components/fields/FieldError.vue';

export default {
	components: { FieldError },
	props: ['id', 'label', 'mandatory', 'errors', 'show_password_toggle'],
	data() {
		return {
			input_field: null,
			password_visible: false,
		}
	},
	methods: {
		togglePasswordVisibility() {
			this.password_visible = !this.password_visible;
			this.input_field.type = this.password_visible ? 'text' : 'password';
		}
	},
	mounted() {
		this.input_field = this.$refs.input_field.children[0];

		if (this.input_field.classList.contains('typeahead-wrapper')) {
			this.input_field = this.input_field.getElementsByTagName('input')[0];
		}

		this.input_field.setAttribute('id', this.id);
		this.input_field.setAttribute('ref', this.id);
	}
}
</script>

<style lang='scss' scoped>

.field-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 20px;
	width: 100%;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 6px;
	}
}

.label-wrapper {
	min-width: 160px;
	display: flex;
	align-items: center;
	flex-shrink: 0;

	@media (max-width: 768px) {
		min-width: unset;
	}
}

.label {
	font-size: 0.95rem;
	color: var(--medium-grey);
	// font-weight: 500;
}

.mandatory {
	font-size: 0.4rem;
	vertical-align: text-top;
	margin-top: -10px;
	margin-left: 5px;
	color: #e03131;
}

.field-wrapper {
	flex: 1;
	width: 100%;
}

.input-field {
	position: relative;
	width: 100%;
}

.password-toggle-btn {
	position: absolute;
	right: 6px;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	color: var(--black);
	display: flex;
	align-items: center;
	opacity: 0.6;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 1;
	}
}

:deep(.input-field > input),
:deep(.input-field > select) {
	box-sizing: border-box;
	height: 40px;
	border: none;
	border-bottom: 1px solid rgba(185, 179, 174, 1);
	border-radius: 0;
	padding: 0 40px 0 2px;
	font-size: 1rem;
	width: 100%;
	color: var(--black);
	background: transparent;
}

:deep(.input-field > input:focus),
:deep(.input-field > select:focus) {
	outline: none;
	border-bottom-color: var(--black);
}

:deep(.input-field > textarea) {
	box-sizing: border-box;
	border: none;
	border-bottom: 1px solid rgba(185, 179, 174, 1);
	padding: 8px 2px;
	font-size: 1rem;
	color: var(--black);
	font-family: "proxima-nova";
	width: 100%;
	background: transparent;
	resize: vertical;
}

:deep(.input-field > textarea:focus) {
	outline: none;
	border-bottom-color: var(--black);
}

</style>
